<script setup lang="ts">
</script>

<template>
    <div
        class="kidzonet-policy-icon"
        aria-hidden="true"
    >
        <slot />
    </div>
</template>

<style>
    .kidzonet-policy-icon {
        display: flex;
        align-items: center;
        justify-content: center;

        min-inline-size: 48px;
        min-block-size: 48px;
        border-radius: 12px;

        @media(max-width: 600px) {
            display: none;
        }
    }
</style>
